import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import palette from './palette';

const theme = responsiveFontSizes(
  createTheme({
    typography: {
      fontFamily:
        'Rethink Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    },
    palette,
    shape: {
      borderRadius: 16,
    },
    components: {
      MuiButton: {
        defaultProps: {
          disableElevation: true,
          style: {
            textTransform: 'initial',
          },
        },
        styleOverrides: {
          sizeSmall: {
            height: '32px',
            borderRadius: '8px',
            fontWeight: 700,
            padding: '0 16px',
            fontSize: '14px',
          },
          sizeLarge: {
            height: '48px',
            borderRadius: '8px',
            fontWeight: 700,
            padding: ' 0 16px',
            fontSize: '14px',
          },
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            color: palette.info.main,
            textDecorationColor: palette.info.light,
            '&:hover': {
              color: palette.info.dark,
            },
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          size: 'small',
        },
      },
    },
  }),
);

export default theme;
